import React, { useContext, useEffect, useState } from 'react';
import { I18nextContext } from 'gatsby-plugin-react-i18next';
import * as CookieConsent from "vanilla-cookieconsent";
import * as enLang from '../../locales/en/cookieConsent.json';
import * as twLang from '../../locales/tw/cookieConsent.json';

export default function Root({children}: {children: JSX.Element}) {
  const context = useContext(I18nextContext);
  const [isCookieCompelete, setIsCookieComplete] = useState(false);

  useEffect(() => {
    CookieConsent.run({
      categories: {
        necessary: {
          enabled: true,
          readOnly: true
        },
        marketing: {
          enabled: false,
          readOnly: false
        }
      },
      language: {
        default: 'en',
        autoDetect: 'document',
        translations: {
          en: enLang,
          tw: twLang,
        }
      }
    }).then(() => setIsCookieComplete(true));
  })

  useEffect(() => {
    if (isCookieCompelete) {
      CookieConsent.setLanguage(context.language, true);
    }
  }, [context, isCookieCompelete]);
  
  return (
    <>
      {children}
    </>
  )
}